<template>
  <div>
    <user-details ref="userDetails" :can-change-role="false">
      <div slot="cropper">
        <photo-cropper
          v-model="photo"
          name="driver"
          :photo-storage-path="accountUser.driver_profile.photo_storage_path"
          :original-name="accountUser.driver_profile.photo_name"
          :original-data-uri="originalPhotoDataUri"
          class-name="profile-photo"
          label-text="Profile Photo">
        </photo-cropper>
      </div>
    </user-details>

    <ladda-button :on-click="saveAccountUser" class="btn btn-success"><i class="fa fa-check"></i> Save</ladda-button>

    <div class="decorative-divider"></div>

    <div class="margin-50"></div>
  </div>
</template>

<script>
  import { mapState, mapActions, mapMutations } from 'vuex'
  import { SET_ACCOUNT_USER, SET_ACCOUNT_USER_ATTRIBUTE, RESET_ACCOUNT_USER } from 'vx/mutations'
  import { Selectize, LaddaButton, DateRange, PhotoCropper } from 'components/forms'
  import { merge, forIn, each } from 'lodash'
  import { stateMapper } from 'mixins/user'
  import { Roles } from 'utils/user'
  import UserDetails from './../user/UserDetails'
  import notify from 'utils/notify'

  export default {
    mixins: [stateMapper],

    data () {
      return {
        stateProperty: 'accountUser',
        mutationProperty: SET_ACCOUNT_USER_ATTRIBUTE,
        photo: null,
        originalPhotoDataUri: null
      }
    },

    components: {
      Selectize,
      LaddaButton,
      DateRange,
      PhotoCropper,
      UserDetails
    },

    computed: {
      ...mapState('user/accountUsers', ['accountUser']),

      /**
       * Payload to send with request.
       *
       * @return object
       */
      payload () {
        return {
          name: this.name,
          email: this.email,
          mobile: this.mobile,
          role_id: Roles.DRIVER,
          licence: this.licence,
          licence_expiry: this.licenceExpiry
        }
      },

      /**
       * Get and set a users name on their profile.
       */
      name: {
        get () {
          return this.accountUser.profile.full_name
        },

        set (value) {
          this[SET_ACCOUNT_USER_ATTRIBUTE]({ attribute: 'profile.full_name', value })
        }
      }
    },

    created () {
      this[RESET_ACCOUNT_USER]()
      let driverRoleId = Roles.DRIVER
      this[SET_ACCOUNT_USER_ATTRIBUTE]({ attribute: 'role_id', value: driverRoleId })
    },

    methods: {
      ...mapActions('user/accountUsers', ['storeAccountUser']),
      ...mapActions('driver', ['getDriverPhotoDataUri', 'uploadDriverPhoto']),
      ...mapActions('user', ['disableUser', 'enableUser']),
      ...mapMutations('user/accountUsers', [SET_ACCOUNT_USER, SET_ACCOUNT_USER_ATTRIBUTE, RESET_ACCOUNT_USER]),

      saveAccountUser () {
        return this.validateAll()
          .then(() => {
            let payload = merge(this.payload, { parent_id: this.$user.id })
            return this.storeAccountUser(payload)
              .then(this.updateAccountUserState)
              .then(this.handlePhotoUpload)
              .then(this.redirectToEditDriver)
              .catch(exception => {
                if (exception.response && exception.response.status === 422) {
                  forIn(exception.response.data.errors, (errors, key) => {
                    each(errors, error => {
                      this.$refs.userDetails.errors.add(key, error)
                      notify.error(error)
                    })
                  })
                }
              })
          })
      },

      /**
       * Update an account user state after a saving action.
       *
       * @param object response
       *
       * @return Promise
       */
      updateAccountUserState (response) {
        this[SET_ACCOUNT_USER](response.data)

        return Promise.resolve(response)
      },

      /**
       * Redirect to edit driver.
       *
       * @param object response
       *
       * @return void
       */
      redirectToEditDriver (response) {
        this.$router.push({ name: 'drivers.edit', params: { id: this.accountUser.id } })
      },

      /**
       * Handle uploading driver photo.
       *
       * @param object response
       *
       * @return Promise
       */
      handlePhotoUpload (response) {
        if (this.photo && response.data.driver_id) {
          return this.uploadDriverPhoto({ id: response.data.driver_id, file: this.photo.file, crop: this.photo.crop })
        }

        return Promise.resolve(response)
      }
    }
}
</script>




// WEBPACK FOOTER //
// Form.vue?5557787c